import { useActiveMenuItem } from "../store";
import { MenuItems } from "../types";

export const useIsSelectedNavigateMenuItem = (menuItem: MenuItems): boolean => {
  const activeMenuItem = useActiveMenuItem();

  return activeMenuItem === menuItem;
};
